<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 6L24 16L7 26L7 6Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'ChevronRight' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
